import React from 'react';

// Check if analytics is enabled (default to false if not set)
const ANALYTICS_ENABLED = self.ENABLE_ANALYTICS === 'true';

// Event types
export const EVENT_TYPES = {
  PAGE_VIEW: 'page_view',
  LISTING_VIEW: 'listing_view',
  LISTING_CONTACT: 'listing_contact',
  SEARCH: 'search',
  ERROR: 'error',
  FEATURE_USAGE: 'feature_usage',
};

// Analytics tracking function
export const trackEvent = (eventType, eventData = {}) => {
  if (!ANALYTICS_ENABLED) {
    return;
  }

  // Add timestamp and environment info
  const enhancedData = {
    ...eventData,
    timestamp: new Date().toISOString(),
    environment: self.ENV || 'production',
  };

  // TODO: Replace with actual analytics service implementation
  console.log('Analytics Event:', {
    type: eventType,
    data: enhancedData,
  });
};

// Utility functions for common events
export const analytics = {
  trackPageView: (page) => {
    trackEvent(EVENT_TYPES.PAGE_VIEW, { page });
  },

  trackListingView: (listingId, listingName) => {
    trackEvent(EVENT_TYPES.LISTING_VIEW, { listingId, listingName });
  },

  trackListingContact: (listingId, listingName) => {
    trackEvent(EVENT_TYPES.LISTING_CONTACT, { listingId, listingName });
  },

  trackSearch: (query, resultCount) => {
    trackEvent(EVENT_TYPES.SEARCH, { query, resultCount });
  },

  trackError: (error, componentName) => {
    trackEvent(EVENT_TYPES.ERROR, {
      message: error.message,
      stack: error.stack,
      component: componentName,
    });
  },

  trackFeatureUsage: (featureName, metadata = {}) => {
    trackEvent(EVENT_TYPES.FEATURE_USAGE, {
      feature: featureName,
      ...metadata,
    });
  },
};

// HOC to wrap components with analytics
export const withAnalytics = (WrappedComponent, componentName) => {
  return function AnalyticsWrapper(props) {
    React.useEffect(() => {
      if (ANALYTICS_ENABLED) {
        analytics.trackPageView(componentName);
      }
    }, []);

    return <WrappedComponent {...props} />;
  };
};
